import groupTracking from '@/api/sale/group-tracking'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations,
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return groupTracking.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return groupTracking.store(data)
  },
  update(context, { id, data }) {
    return groupTracking.update(id, data)
  },
  addUser(context, { id, data }) {
    return groupTracking.addUser(id, data)
  },
  destroy(context, id) {
    return groupTracking.destroy(id)
  },
  find(context, id) {
    return groupTracking.find(id)
  },
  getUser(context) {
    return groupTracking.getUser()
  },
  getGroup(context) {
    return groupTracking.getGroup()
  },
  viewOnMap(context, params) {
    return groupTracking.viewOnMap({ params })
  },
  exportExcel(context, data) {
    return groupTracking.exportExcel(data)
  },
}
